import Typography from '@mui/material/Typography';

import { EllipsisTooltip } from '../EllipsisTooltip';
import { MissionCategoryPath } from '../MissionCategoryPath';

import type { FolderBusinessEntityListCmp_FolderBusinessEntity } from './fragments/folder-business-entity.fragment';

type Mission = Extract<
  FolderBusinessEntityListCmp_FolderBusinessEntity,
  Readonly<{ __typename: 'Mission' }>
>;

interface Props {
  readonly mission: Pick<
    Mission,
    'categoryParentId' | 'categoryLeaf' | 'code' | 'consolidation' | 'type'
  >;
}

export const MissionSummary = ({ mission }: Readonly<Props>) => (
  <>
    {mission.type ? (
      <>
        <Typography
          component="div"
          gutterBottom
          sx={{ lineHeight: 1.2 }}
          variant="h6"
        >
          {mission.type.label}
        </Typography>
        <Typography variant="body2">{mission.consolidation.title}</Typography>
      </>
    ) : (
      <Typography
        component="div"
        gutterBottom
        sx={{ lineHeight: 1.2 }}
        variant="h6"
      >
        {mission.consolidation.title}
      </Typography>
    )}
    <Typography variant="body2">
      <MissionCategoryPath
        categoryLeaf={mission.categoryLeaf}
        categoryParentId={mission.categoryParentId}
      />
    </Typography>
    <EllipsisTooltip title={mission.code}>
      <Typography noWrap variant="body2">
        {mission.code}
      </Typography>
    </EllipsisTooltip>
  </>
);
